<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Bank Card Term {{ (bankCardTerm.name) ? (" - " + bankCardTerm.name) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Bank Card Term - {{bankCardTerm.name}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Bank Card Term - {{bankCardTerm.name}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode == 1">
                <base-input alternative="" label="Code" placeholder="" v-model="bankCardTerm.code" input-classes="form-control"/>
                <base-input alternative="" label="Name" placeholder="" v-model="bankCardTerm.name" input-classes="form-control" required />
                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="bankCardTerm.remark" />
                </base-input>
            </div>
            <div v-if="customFormMode == 2">
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="bankCardTerm" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>
            <div v-if="customFormMode == 3">
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="bankCardTerm.code" input-classes="form-control"/>
                        <base-input alternative="" label="Name" placeholder="" v-model="bankCardTerm.name" input-classes="form-control" required />
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="bankCardTerm.remark" />
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="bankCardTerm" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>

            
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>  
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>

            <!-- <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
            </div> -->
            
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import DynamicForm from '../DynamicForm.vue'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        components:{
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {

            // Meta-data Call
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Bank Card Term?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
                const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
                if(accSystemModule != null){
                    if(accSystemModule.form_mode != undefined){
                        this.customFormMode = accSystemModule.form_mode
                    }
                    if(accSystemModule.customized_forms != undefined){
                        this.customForm = accSystemModule.customized_forms
                    }
                }
            }

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this
            if (component_x.profileId > 0) {
                var bank_card_term_data = await HTTPRequest.getRequest(component_x.endPoint + 'bank_card_terms/' + component_x.profileId, null)
                if (bank_card_term_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (bank_card_term_data["error"] == undefined) {
                        component_x.bankCardTerm = bank_card_term_data
                        component_x.inputName = bank_card_term_data["name"]
                        component_x.inputCode = bank_card_term_data["code"]
                        component_x.inputRemark = bank_card_term_data["remark"]
                    } else {
                        this.errors = bank_card_term_data["error"].split(",")
                    }
                }
            }

            // To handle update on dynamic forms on load
            this.dynamicFormKey++;
        },
        data: function () {
            return {
                errors: [],
                // FOR META-DATA
                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                bankCardTerm: {
                    name: '',
                    code: ''
                },
                formErrors: []
            }
        },
        methods: {
            // meta-data functions
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.bankCardTerm
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors

                if(this.customFormMode == 3) {
                    this.errors = errors
                }

                this.bankCardTerm = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },

            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.bankCardTerm.code));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.bankCardTerm.code));
                this.errors.push(ValidateField.charMinAndMax('Code', this.bankCardTerm.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.bankCardTerm.name));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.bankCardTerm.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.bankCardTerm.name, 0, 50));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    // var bank_card_termPayload = {
                    //     bank_card_term: {
                    //         name: this.inputName.trim(),
                    //         code: this.inputCode.trim(),
                    //         remark: this.inputRemark,
                    //         status: 'A'
                    //     }
                    // }
                    this.bankCardTerm.name = this.bankCardTerm.name.trim()
                    this.bankCardTerm.code = this.bankCardTerm.code.trim()
                    this.bankCardTerm.status = 'A'
                    var bank_card_termPayload = { bank_card_term: this.bankCardTerm }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'bank_card_terms', null, bank_card_termPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    this.bankCardTerm.name = this.bankCardTerm.name.trim()
                    this.bankCardTerm.code = this.bankCardTerm.code.trim()
                    // this.bankCardTerm.status = 'A'
                    let status = (this.bankCardTerm.status == null) ?  "A" : this.bankCardTerm.status
                    this.bankCardTerm.status = status
                    var bank_card_termPayload = { bank_card_term: this.bankCardTerm }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'bank_card_terms/' + this.profileId, null, bank_card_termPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>